import Vue from 'vue';
import Router from 'vue-router';

import Index from './pages/Index.vue';
import InfraServices from './pages/InfraServices.vue';
import TechServices from './pages/TechServices.vue';
import Projects from './pages/Projects.vue';
import Terms from './pages/Terms.vue';
import Policy from './pages/Policy.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';

import NotFound from './pages/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      components: {
        default: Index,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: 'black'
        }
      }
    },
    {
      path: '/infrastructure-services',
      name: 'infrastructure-services',
      components: {
        default: InfraServices,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: 'black'
        }
      }
    },
    {
      path: '/technology-services',
      name: 'technology-services',
      components: {
        default: TechServices,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: 'black'
        }
      }
    },
    {
      path: '/projects',
      name: 'projects',
      components: {
        default: Projects,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: 'black'
        }
      }
    },
    {
      path: '/terms',
      name: 'terms',
      components: {
        default: Terms,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: 'black'
        }
      }
    },
    {
      path: '/policy',
      name: 'policy',
      components: {
        default: Policy,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 100
        },
        footer: {
          backgroundColor: 'black'
        }
      }
    },
    {
      path: '*',
      name: 'not-found',
      components: {
        default: NotFound,
        footer: MainFooter
      },
      props: {
        footer: {
          backgroundColor: 'black'
        }
      }
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return window.scrollTo({
        top: document.querySelector(to.hash).offsetTop,
        behavior: 'smooth'
      });
    } else if (savedPosition) {
      return savedPosition;
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return {
        x: 0,
        y: 0
      }
    }
  }
});